// High-value minerals list (matches database commodity names exactly)
const HIGH_VALUE_MINERALS = [
  'Aluminium (Bauxite)',
  'Chromium',
  'Cobalt',
  'Copper',
  'Graphite',
  'Iridium',
  'Iron',
  'Lithium',
  'Manganese',
  'Nickel',
  'Platinum Group Metals',
  'Rare Earth Elements',
  'Silicon (Silica, Quartz, Feldspar)',
  'Tin',
  'Titanium (Ilmenite, Rutile)',
  'Tungsten',
  'Vanadium',
  'Zinc'
];

// Other critical minerals list (matches database commodity names exactly)
const OTHER_MINERALS = [
  'Antimony',
  'Arsenic',
  'Beryllium',
  'Bismuth',
  'Cesium',
  'Fluorite (Fluorspar)',
  'Gallium',
  'Germanium',
  'Gold',
  'Hafnium',
  'Indium',
  'Magnesium (Magnesite)',
  'Molybdenum',
  'Niobium',
  'Phosphorus (Phosphate Rock)',
  'Radium',
  'Rhenium',
  'Rubidium',
  'Scandium',
  'Silver',
  'Tantalum',
  'Tellurium',
  'Uranium',
  'Yttrium',
  'Zirconium (Zircon)'
];

// Non-critical minerals list (matches database commodity names exactly)
const NON_CRITICAL_MINERALS = [
  'Pyrophyllite',
  'Asbestos',
  'Barium',
  'Bentonite',
  'Boron',
  'Cadmium',
  'Calcium (Limestone, Dolomite)',
  'Corundum',
  'Diamond',
  'Diatomite',
  'Garnet',
  'Granite',
  'Gypsum',
  'Iodine',
  'Kaolin',
  'Kyanite',
  'Lead',
  'Marble',
  'Mercury',
  'Mica',
  'Osmium',
  'Perlite',
  'Potassium (Potash)',
  'Pumice',
  'Pyrite',
  'Salt',
  'Selenium',
  'Sodium',
  'Staurolite',
  'Strontium',
  'Sulfate',
  'Sulfide',
  'Talc',
  'Thallium',
  'Thorium',
  'Travertine',
  'Vermiculite',
  'Wollastonite',
  'Zeolites'
];

// Critical minerals is the combination of high-value and other minerals
const CRITICAL_MINERALS = [...HIGH_VALUE_MINERALS, ...OTHER_MINERALS];

// Direct exports for individual components
export { HIGH_VALUE_MINERALS, OTHER_MINERALS, NON_CRITICAL_MINERALS, CRITICAL_MINERALS };

// Export for ES6 modules
export const commodityConfig = {
  HIGH_VALUE_MINERALS,

  OTHER_MINERALS,

  get CRITICAL_MINERALS() {
    return CRITICAL_MINERALS;
  },

  NON_CRITICAL_MINERALS,

  COMMODITY_COLORS: {
    'aluminium (bauxite)': '#E67E22',
    'chromium': '#34495E',
    'cobalt': '#2980B9',
    'copper': '#B87333',
    'gold': '#FFD700',
    'graphite': '#2C3E50',
    'iridium': '#AED6F1',
    'iron': '#8B4513',
    'lithium': '#9B59B6',
    'manganese': '#8E44AD',
    'nickel': '#95A5A6',
    'platinum': '#E5007D',
    'platinum group metals': '#E5007D',
    'rare earth elements': '#E74C3C',
    'silicon (silica, quartz, feldspar)': '#85929E',
    'silver': '#C0C0C0',
    'tin': '#BDC3C7',
    'titanium (ilmenite, rutile)': '#566573',
    'tungsten': '#2C3E50',
    'vanadium': '#7F8C8D',
    'zinc': '#3498DB'
  },

  UNCOMMON_MATERIAL_COLORS: {
    'crushed stone': '#BDC3C7',
    'construction sand and gravel': '#D5DBDB',
    'cement': '#85929E',
    'salt': '#F8F9FA',
    'gypsum and anhydrite': '#E8DAEF',
    'talc': '#D6EAF8',
    'feldspar': '#FCF3CF',
    'baryte': '#FADBD8',
    'bentonite': '#D5F4E6'
  },

  CRITICAL_COMMODITY_COLOR: '#FF6B6B',
  NON_CRITICAL_COMMODITY_COLOR: '#5B6ABF',
  DEFAULT_COMMODITY_COLOR: '#6B7280'
};

// Export for CommonJS (for use in Node.js API)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    HIGH_VALUE_MINERALS,
    OTHER_MINERALS,
    NON_CRITICAL_MINERALS,
    CRITICAL_MINERALS,
    commodityConfig
  };
}